/**
 * Транспортное кодирование содержимого сообщения. **Это не шифрование.**
 *
 * <p>Base64 не скрывает ничего: сервер штатно разбирает payload и строит по нему
 * превью для списка чатов, тексты пушей и состояние общих чек-листов. Поле в API
 * называется `ciphertext` по историческим причинам; менять имя — отдельная
 * задача, а вот подразумевать по нему криптографию нельзя.
 *
 * <p>Прежний комментарий здесь гласил, что имя поля подобрано «под E2E-ready
 * payload», и читался как «шифрование вот-вот будет». Его нет, и решение о том,
 * появится ли оно, зафиксировано отдельно: `docs/decisions/001-e2ee.md`.
 */
export function utf8ToBase64(s: string): string {
  const bufferCtor = (globalThis as { Buffer?: typeof Buffer }).Buffer;
  if (typeof bufferCtor !== 'undefined') {
    return bufferCtor.from(s, 'utf8').toString('base64');
  }

  if (typeof TextEncoder !== 'undefined' && typeof btoa !== 'undefined') {
    const bytes = new TextEncoder().encode(s);
    let binary = '';
    const chunkSize = 0x8000;
    for (let i = 0; i < bytes.length; i += chunkSize) {
      const chunk = bytes.subarray(i, i + chunkSize);
      let piece = '';
      for (let j = 0; j < chunk.length; j += 1) {
        piece += String.fromCharCode(chunk[j]);
      }
      binary += piece;
    }
    return btoa(binary);
  }

  return btoa(unescape(encodeURIComponent(s)));
}

export function base64ToUtf8(b: string): string {
  const bufferCtor = (globalThis as { Buffer?: typeof Buffer }).Buffer;
  if (typeof bufferCtor !== 'undefined') {
    return bufferCtor.from(b, 'base64').toString('utf8');
  }

  if (typeof TextDecoder !== 'undefined' && typeof atob !== 'undefined') {
    const binary = atob(b);
    const bytes = new Uint8Array(binary.length);
    for (let i = 0; i < binary.length; i += 1) {
      bytes[i] = binary.charCodeAt(i);
    }
    return new TextDecoder().decode(bytes);
  }

  return decodeURIComponent(escape(atob(b)));
}
